import { Component, Fragment } from "react";

interface NHCPinoutElementLineProps {
  x1: number;
  x2: number;
  y1: number;
  y2: number;
  text: string;
  key: string;
  direction: number;
}

interface NHCPinoutElementLineState {
  data: []
}

export class NHCPinoutElementLine extends Component<NHCPinoutElementLineProps, NHCPinoutElementLineState> {

  constructor(props: NHCPinoutElementLineProps) {
    super(props);
    this.state = {
      data: []
    };
  }

  render() {
    const {x1, x2, y1, y2, text} = this.props;

    let rotate = -90;

    let textAnchor = 'start';
    let yTopMargin = 0;
    let xLeftMargin = 0;

    if (this.props.direction == 2) {
      rotate = 270;
      yTopMargin = 87;
      xLeftMargin = 2;
      textAnchor = 'end';
    }

    return <Fragment>
      <line x1={x1} y1={y1} x2={x2} y2={y2} style={{ stroke: "black", strokeWidth : 1 }} />
      <text
            x={0} y={0} textAnchor={textAnchor as "start" | "middle" | "end" | "inherit"} dominantBaseline={undefined}
            transform={`translate(${x1 + 1 + xLeftMargin } ${y1 - 82 + yTopMargin}) rotate(${rotate})`}
            className="port-text"
            fontSize="9.6"
      >
        {text}
      </text>
    </Fragment>
  }
}
